/* unplugin-vue-components disabled */import { render } from "./Livestream.vue?vue&type=template&id=77b505c8&scoped=true"
import script from "./Livestream.vue?vue&type=script&lang=js"
export * from "./Livestream.vue?vue&type=script&lang=js"

import "./Livestream.vue?vue&type=style&index=0&id=77b505c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b505c8"]])

export default __exports__